<ng-container *ngIf="!directForm else directHeader" >
  <header
    [currentStep]="currentStep"
    [isMobile]="isMobile"
    (goToStep)="currentStep = $event"
  ></header>
</ng-container>
<!-- [style.height]="getContinerHeight()" -->
<div class="body" [ngClass]="{'mobileBody' : isMobile}" >
  <ng-container *ngIf="currentStep === 'contact-info'" [ngTemplateOutlet]="contactInfo"></ng-container>
  <ng-container *ngIf="currentStep === 'form'" [ngTemplateOutlet]="form"></ng-container>
</div>
<div class="footer" [ngClass]="{'mobileFooter' : isMobile}">
  <ng-container *ngIf="currentStep === 'contact-info'" [ngTemplateOutlet]="contactInfoFooter"></ng-container>
  <ng-container *ngIf="currentStep === 'form' && requestResult === 'form'" [ngTemplateOutlet]="requestFooter"></ng-container>
</div>

<ng-template #directHeader>
  <div class="directTitleContainer" *ngIf="requestResult === 'form'">
    <div class="title">
      {{'FORM.DIRECT_FORM.TITLE' | translate}}
    </div>
    <div class="subTitle">
      {{'FORM.DIRECT_FORM.SUB_TITLE' | translate}}
    </div>
  </div>

</ng-template>

<ng-template #contactInfo>
  <contactForm
    (contactForm)="initForms('contact-info',$event)"
    (phontDetails)="phontData = $event"
  ></contactForm>
</ng-template>

<ng-template #form>
  <ng-container *ngIf="requestResult === 'success'" [ngTemplateOutlet]="ticketSuccess"></ng-container>
  <ng-container *ngIf="requestResult ==='fail'" [ngTemplateOutlet]="ticketError"></ng-container>
  <requestForm
    *ngIf="requestResult === 'form'"
    [directForm]="directForm"
    (requestForm)="initForms('form',$event)"
    [requestUser]="requestUser"
    [loading]="loading"
  ></requestForm>
</ng-template>

<ng-template #contactInfoFooter>
  <!-- <div class="remark">{{'FORM.FOOTER.CONTACT_FORM_REMARK' | translate}} <span class="as-link" (click)="toPortal()">{{'FORM.FOOTER.SING_IN_LINK' | translate}} </span></div> -->

  <div class="remark" *ngIf="!isMobile">{{'FORM.FOOTER.REQUEST_REMARK' | translate}}</div>
  <button  class="home365-button primary flex center-vr" [ngClass]="{'home365-mobile-button': isMobile,'disable' : !contactForm.valid}"(click)="submit()">

    {{'FORM.FOOTER.NEXT_STEP_BUTTON' | translate}}
  </button>
  <div class="remark" *ngIf="isMobile">{{'FORM.FOOTER.REQUEST_REMARK' | translate}}</div>
</ng-template>

<ng-template #requestFooter>
  <div class="remark" *ngIf="!isMobile">{{'FORM.FOOTER.REQUEST_REMARK' | translate}}</div>
  <button  class="home365-button primary flex center-vr" [ngClass]="{'home365-mobile-button': isMobile,'disable' : requestForm && !requestForm.valid}" (click)="submit()">
    {{'FORM.FOOTER.SUBMIT_BUTTON' | translate}}
  </button>
  <div class="remark" *ngIf="isMobile">{{'FORM.FOOTER.REQUEST_REMARK' | translate}}</div>
</ng-template>


<div class="spinnerBox" *ngIf="loading">
  <home365-loader [white]="false" [size]="'xxl'"></home365-loader>
</div>


<ng-template #ticketError>
  <div class="ticketMessageContainer">
    <div class="ticketMessage">
        <img src="./assets/img/ticket_error.svg">
        <div class="ticketTitle">{{ 'FORM.REQUEST_FORM.FAIL.TITLE' | translate }}</div>
        <div class="ticketText">{{ 'FORM.REQUEST_FORM.FAIL.TEXT' | translate }}</div>
    </div>
    <div class="footer">
        <button class="home365-button primary flex center-vr" (click)="close()" [ngClass]="{'home365-mobile-button': isMobile}">
            {{'FORM.REQUEST_FORM.FAIL.BUTTON' | translate}}
        </button>
    </div>
  </div>
</ng-template>

<ng-template #ticketSuccess>
  <div class="ticketMessageContainer">
    <div class="ticketMessage">
      <img src="./assets/img/ticket_success.svg">
      <div class="ticketTitle">{{ 'FORM.REQUEST_FORM.SUCESS.TITLE' | translate }}</div>
      <div class="ticketText">{{ 'FORM.REQUEST_FORM.SUCESS.TEXT' | translate }}</div>
    </div>
    <div class="footer">
        <button class="home365-button primary flex center-vr" (click)="close()" [ngClass]="{'home365-mobile-button': isMobile}">
            {{'FORM.REQUEST_FORM.SUCESS.BUTTON' | translate}}
        </button>
    </div>
  </div>
</ng-template>
